<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup" @closed="closedAddress">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{ addressId && addressId != 9999 ? $t('修改地址') : $t('新增地址')}}
			</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<el-form ref="form" :model="form">
					<el-form-item>
						<el-input v-model="form.name" :placeholder="$t('请输入姓名')"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="form.phone" :placeholder="$t('请输入电话号码')"></el-input>
					</el-form-item>
					<el-form-item>
						<el-row :gutter="16" :class="isMobileFlag?'m-diqu':''">
						      <el-col :span="isMobileFlag?24:8">
						        <el-select
						          v-model="form.provinces"
						          :placeholder="$t('请选择省份')"
						          @change="onProvinceChange"
						        >
						          <el-option
						            v-for="province in provinces"
									:key="province.id"
						            :label="province.province_name"
						            :value="province.province_name"
						          >
						            {{ province.province_name }}
						          </el-option>
						        </el-select>
						      </el-col>
						      <el-col :span="isMobileFlag?24:8">
						        <el-select
						          v-model="form.area"
						          :placeholder="$t('请选择市区')"
						          @change="onDistrictChange"
						          :disabled="!form.provinces"
						        >
						          <el-option
						            v-for="district in districts"
									:key="district.id"
						            :label="district.district_name"
						            :value="district.district_name"
						          >
						            {{ district.district_name }}
						          </el-option>
						        </el-select>
						      </el-col>
						      <el-col :span="isMobileFlag?24:8">
						        <el-select
						          v-model="form.wards"
						          :placeholder="$t('请选择乡镇')"
								  @change="onwardsChange"
						          :disabled="!form.area"
						        >
						          <el-option
						            v-for="ward in wards"
									:key="ward.id"
						            :label="ward.ward_name"
						            :value="ward.ward_name"
						          >
						            {{ ward.ward_name }}
						          </el-option>
						        </el-select>
						      </el-col>
						    </el-row>
					</el-form-item>
					<el-form-item>
						<el-input v-model="form.detail" :placeholder="$t('详细地址')"></el-input>
					</el-form-item>
					<el-form-item>
						<el-checkbox v-model="form.is_default" :true-label="1" :false-label="0"
							@change="checkboxChange">
							{{$t('设为默认地址')}}
						</el-checkbox>
					</el-form-item>
					<el-row :gutter="20" class="btn-foot-row">
						<el-col :span="12">
							<el-button round @click="show = false" type="warning">
								{{$t('取消')}}
							</el-button>
						</el-col>
						<el-col :span="12">
							<el-button round type="primary" @click="onSubmit">
								{{$t('确定')}}
							</el-button>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
	</van-popup>

</template>
<script>
	import axios from 'axios';
	import {
		address_save_api,
		address_detail_api
	} from "@/api/user"
	export default {
		components: {},
		props: {
			addressId: {
				type: Number,
				default: 9999
			}
		},
		data() {
			return {
				show: false,
				selecQu: '',
				form: {
					id: '',
					name: '',
					phone: '',
					provinces: '',
					area: '',
					wards: '',
					provinces_id: '',
					area_id: '',
					wards_id: '',
					detail: '',
					is_default:true
				},
				provinces: [],
				districts: [],
				wards: [],
			};
		},
		
		methods: {
			empty() {
				this.form.name = ""
				this.form.phone = ""
				this.form.provinces = ""
				this.form.area = ""
				this.form.wards = ""
				this.form.detail = ""
				this.form.provinces_id = ""
				this.form.area_id = ""
				this.form.wards_id = ""
				this.form.is_default = true
			},
			closedAddress(){
				this.empty()
			},
			async getAddressDetail(getid) {
				this.empty()
				let data = {
					id: getid
				}
				console.log(data,'getAddressDetail')
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await address_detail_api(data).then(res => {
					loading.close()
					if (res && res.data.code == 1) {
						console.log(res.data)
						this.form.name = res.data.data.name
						this.form.phone = res.data.data.phone
						this.form.provinces = res.data.data.provinces
						this.form.area = res.data.data.area
						this.form.wards = res.data.data.wards
						this.form.provinces_id = res.data.data.provinces_id
						this.form.area_id = res.data.data.area_id
						this.form.wards_id = res.data.data.wards_id
						this.form.detail = res.data.data.detail
						this.form.is_default = Number(res.data.data.is_default)
						this.fetchDistricts(this.form.provinces_id)
						this.fetchWards(this.form.area_id)
					}
				});
			},
			async onSubmit() {
				if (this.form.name == "") {
					this.errorTips('请输入姓名');
					return false;
				}
				if (this.form.phone == "") {
					this.errorTips('请输入电话号码');
					return false;
				}
				if (this.form.provinces == "") {
					this.errorTips('请选择省份');
					return false;
				}
				if (this.form.area == "") {
					this.errorTips('请选择市区');
					return false;
				}
				if (this.form.wards == "") {
					this.errorTips('请选择乡镇');
					return false;
				}
				if (this.form.detail == "") {
					this.errorTips('详细地址');
					return false;
				}
				let data = {
					name: this.form.name,
					phone: this.form.phone,
					provinces: this.form.provinces,
					area: this.form.area,
					wards: this.form.wards,
					provinces_id: this.form.provinces_id,
					area_id: this.form.area_id,
					wards_id: this.form.wards_id,
					detail: this.form.detail,
					is_default: Number(this.form.is_default),
				}
				if (this.addressId != 9999) {
					data['id'] = this.addressId
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await address_save_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.successTips(res.data.msg)
						this.show = false
						this.$emit('update-addresses');
						if(this.isMobileFlag){
							window.location.reload()
						}
					}
					loading.close()
				});
			},
			checkboxChange(e) {
				console.log(e)
			},
			showEditDialog() {
				if(this.addressId !== 9999 ){
					this.getAddressDetail(this.addressId);
				}
				this.show = true
			},
			fetchProvinces() {
				axios.get('https://apisandbox.ntlogistics.vn/v1/loc/provinces', {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.provinces = response.data.data;
						this.form.provinces_id = response.data.data[0].id;
					})
					.catch(error => {
						console.error('Error fetching provinces:', error);
					});
			},
			onProvinceChange(provinceName) {
				this.form.provinces = '';
				this.form.area = '';
				this.form.wards = '';
				this.form.provinces = provinceName;
				const selectedProvince = this.provinces.find(province => province.province_name === provinceName);
				this.form.provinces_id = selectedProvince.id;
				this.fetchDistricts(selectedProvince.id);
			},
			fetchDistricts(provinceId) {
				axios.get(`https://apisandbox.ntlogistics.vn/v1/loc/districts?province_id=${provinceId}`, {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.districts = response.data.data;
					})
					.catch(error => {
						console.error('Error fetching districts:', error);
					});
			},
			onDistrictChange(districtName) {
				this.form.area = '';
				this.form.wards = '';
				this.form.area = districtName;
				const selectedDistrict = this.districts.find(district => district.district_name === districtName);
				this.fetchWards(selectedDistrict.id);
				this.form.area_id = selectedDistrict.id;
			},
			onwardsChange(wardName){
				const selectedwards = this.wards.find(ward => ward.ward_name === wardName);
				this.form.wards_id = selectedwards.id;
			},
			fetchWards(districtId) {
				axios.get(`https://apisandbox.ntlogistics.vn/v1/loc/wards?district_id=${districtId}`, {
						headers: {
							'username': 'bbeauty',
							'password': 'dbea3cef248d01e6f4d3d61c6149a8fc482c1751'
						}
					})
					.then(response => {
						this.wards = response.data.data;
					})
					.catch(error => {
						console.error('Error fetching wards:', error);
					});
			},
		},
		mounted() {
			this.fetchProvinces()
		}
	}
</script>
<style scoped>
	.qhClass {
		margin-right: 10px;
	}

	.get-code {
		border-radius: 0;
		margin-left: 10px;
	}

	.btn-foot-row {
		padding: 10px 0;
	}

	.btn-foot-row .el-button {
		width: 100%;
	}

	.el-select {
		width: 100%;
	}
	.m-diqu .el-col{
		margin-bottom:22px;
	}
	.m-diqu .el-col:last-child{
		margin-bottom:0;
	}
	
	
	
	
	
</style>